module.exports = __webpack_public_path__ + "static/img/news3.8a580a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/news3.jpg
// module id = UpGE
// module chunks = 1